import router from '@/router';
import { store } from '../store/store';
import { EventReportingStore } from '../service/getData';
import md5 from 'js-md5';
import { GenerateBrowserFingerprint } from './init';

let BaseParams = {
	business: {},
	common: {},
	page: {},
	ts: null
};

function getOS() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// 检测操作系统
	if (/windows phone/i.test(userAgent)) {
		return 'Windows Phone';
	}
	if (/win/i.test(userAgent)) {
		return 'Windows';
	}
	if (/android/i.test(userAgent)) {
		return 'Android';
	}
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return 'IOS';
	}
	if (/Macintosh|Mac OS X/.test(userAgent)) {
		return 'MacOS';
	}

	return 'h5_m';
}

let mid = GenerateBrowserFingerprint();
let os = getOS(); //android/ios/web/pc/h5_m(m站)

/**
 * 埋点上报
 * @param {BaseParams} params common不需要传递，如要修改，请在底层添加字段
 * @returns
 */
export const EventReport = (params = {}) => {
	let uid = store.state.userInfo.userId || store.state.userInfo.mobile || '';
	let ts = new Date().getTime();
	let sign = md5('XUBEIEVENT' + ts);
	let headers = {
		'Content-Type': 'multipart/form-data',
		ts,
		sign
	};
	params.common = {
		ch: store.state.virtualChannel || store.state.channel || store.state.businessNo,
		mid,
		uid,
		os
	};
	params.ts = ts;
	let formData = new FormData();
	formData.append('jsonData', JSON.stringify(params));
	return EventReportingStore(formData, headers);
};



// WEBPACK FOOTER //
// ./src/util/eventReport.js